<template>
  <v-app>
    <AppLayout>
      <router-view />
    </AppLayout>
  </v-app>
</template>

<script>  
import AppLayout from '@/layouts/AppLayout'

export default {
  name: 'App',
  components: {
    AppLayout
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
@import 'styles/_grid.scss';
@import 'styles/_typography.scss';

.v-application--wrap {
  overflow-x: hidden;
}
</style>